// extracted by mini-css-extract-plugin
export default {"cls1":"ResearchInterestTags-cls1__Xy","cls2":"ResearchInterestTags-cls2_Koi ResearchInterestTags-cls1__Xy"};